import {
  IBookInterval,
  ILineInfo,
  ILineInfoData,
  ITurn,
} from "./lineInfo.types";
import { LineTypeCode, LineTypeName } from "@/types";

export class LineInfo implements ILineInfo {
  readonly id?: string;
  readonly lineNum: string;
  readonly routeName: string;
  readonly lineNameDisplayText: string;
  readonly campusCode: string;
  readonly campusName: string;
  readonly lineDirectionCode: string;
  readonly lineDirectionName: string;
  readonly lineDistrictCode: string;
  readonly lineDistrictName: string;
  readonly turns: Array<ITurn>;
  readonly schedules: Array<string>;
  readonly isBusRunning?: boolean;
  readonly lineTypeCode: LineTypeCode;
  readonly lineTypeName: LineTypeName;
  readonly district: string;
  readonly dailyBookInterval?: IBookInterval;
  readonly monthlyBookInterval?: IBookInterval;
  readonly detourBeginDtm?: string;
  readonly detourEndDtm?: string;
  readonly detourReason?: string;

  constructor(data: ILineInfoData) {
    this.id = data.id;
    this.lineNum = data.lineNum;
    this.routeName = data.routeName;
    this.lineNameDisplayText = data.lineNameDisplayText;
    this.campusCode = data.campusCode;
    this.campusName = data.campusName;
    this.lineDirectionCode = data.lineDirectionCode;
    this.lineDirectionName = data.lineDirectionName;
    this.lineDistrictCode = data.lineDistrictCode;
    this.lineDistrictName = data.lineDistrictName;
    this.turns = data.turns;
    this.schedules = data.schedules;
    this.isBusRunning = data.isBusRunning;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.district = data.district;
    this.dailyBookInterval = data.dailyBookInterval;
    this.monthlyBookInterval = data.monthlyBookInterval;
    this.detourBeginDtm = data.detourBeginDtm;
    this.detourEndDtm = data.detourEndDtm;
    this.detourReason = data.detourReason;
  }

  validate(data: ILineInfoData): void {
    if (!data.id) {
      throw new Error("Invalid lineInfo");
    }
  }
}
